import React from 'react';
import { motion } from 'framer-motion';
import BrandLogo from '../components/brand/BrandLogo';

const Settings = () => {
  return (
    <div className="max-w-4xl mx-auto space-y-8 pb-12">
      <div>
        <h1 className="text-3xl font-bold text-white tracking-tight">Platform Configuration</h1>
        <p className="text-slate-400 mt-2">Fine-tune the ChurnSignal retention algorithms.</p>
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-[#13131a] border border-white/5 rounded-3xl p-8 md:p-10 space-y-10"
      >
        <section>
          <div className="flex items-center gap-3 mb-6">
            <div className="w-1 h-6 bg-violet-500 rounded-full"></div>
            <h2 className="text-xl font-bold text-white uppercase tracking-tight">Health Score Weights</h2>
          </div>
          <div className="space-y-6">
            {[
              { name: 'Product Usage (Logins, Feature Hits)', val: 85 },
              { name: 'Support Tickets (Velocity & Sentiment)', val: 45 },
              { name: 'Net Promoter Score (NPS / CSAT)', val: 65 },
              { name: 'Executive Pulse (Engagement Index)', val: 90 }
            ].map((metric, idx) => (
              <div key={metric.name} className="space-y-2">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-slate-300">{metric.name}</span>
                  <span className="text-xs font-mono text-violet-400">{metric.val}% Weight</span>
                </div>
                <input 
                  type="range" 
                  defaultValue={metric.val} 
                  className="w-full h-1.5 bg-white/5 rounded-lg appearance-none cursor-pointer accent-violet-500"
                />
              </div>
            ))}
          </div>
        </section>

        <div className="h-px bg-white/5 w-full"></div>

        <section>
          <div className="flex items-center gap-3 mb-6">
            <div className="w-1 h-6 bg-emerald-500 rounded-full"></div>
            <h2 className="text-xl font-bold text-white uppercase tracking-tight">Connected Ecosystem</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {['Salesforce', 'HubSpot', 'Zendesk', 'Gainsight'].map(integration => (
              <div key={integration} className="p-5 border border-white/5 rounded-2xl bg-[#0a0a0f] flex justify-between items-center group hover:border-violet-500/30 transition-all">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center font-bold text-slate-400 group-hover:text-violet-400 transition-colors">
                    {integration[0]}
                  </div>
                  <span className="font-bold text-slate-200">{integration}</span>
                </div>
                <button className="text-[10px] uppercase font-bold tracking-widest px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10 text-slate-400 hover:text-white transition-all border border-white/5">
                  Settings
                </button>
              </div>
            ))}
          </div>
        </section>

        <section className="pt-10 flex flex-col items-center justify-center text-center">
            <BrandLogo size="md" className="mb-4 opacity-50" />
            <h3 className="text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">System Core</h3>
            <p className="text-xs text-slate-600 font-mono mb-6">v2.1.0-STABLE.BUILD_442</p>
            <div className="p-4 px-8 rounded-full bg-white/[0.02] border border-white/5 inline-block">
                <p className="text-xs text-slate-500 font-bold tracking-widest uppercase">
                    Made by <span className="text-slate-300">LingLink AI</span> & <span className="text-slate-300">DigLab AI</span>
                </p>
            </div>
        </section>
      </motion.div>
    </div>
  );
};

export default Settings;